<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <li class="active">パスワード変更</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>パスワード変更</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div class="tab-content">
            <div class="row">
              <div class="col-xs-12">
                <div class="alert alert-danger" v-if="error">
                  {{ message }}
                </div>
                <div class="alert alert-success" v-if="sucessStatus">
                  {{ message }}
                </div>
                <p>
                  現在のログインパスワードと、新しいログインパスワードを入力してください。
                </p>
                <h3>ログインパスワードを変更する ：</h3>
                <!-- PAGE CONTENT BEGINS -->
                <form @submit.prevent="validateBeforeSubmit" class="UserChanegePassword">
                  <ul class="none-list">
                    <li>
                    <label class="clearfix">
                      <span v-show="errors.has('oldPassword')" class="block error">{{ errors.first('oldPassword') }}</span>
                      <span class="label_title">現在のパスワード</span>
                      <span class="input-icon input-icon-right">
                        <input :class="{ error: errors.has('oldPassword') }" v-validate="'required'" id= "oldPassword" name="oldPassword" type="password" class="form-control" placeholder="現在のパスワード" v-model="credentials.oldPassword"/>
                        <i class="ace-icon fa fa-lock"></i>
                      </span>
                    </label>
                    <span class="oldpassword-showhide">
                      <span class="show-password" @click="showhidePassword('oldPassword' , 'show-password', 'oldpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                      <span class="hide-password" @click="showhidePassword('oldPassword' , 'hide-password', 'oldpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                    </span>
                    </li>
                    <li>
                    <span id="passworderror" class="error_m block error"></span>
                    <label class="clearfix">
                      <span v-show="errors.has('newPassword')" class="block error">{{ errors.first('newPassword') }}</span>
                      <span class="label_title">新しいパスワード</span>
                      <span class="input-icon input-icon-right">
                        <input :class="{ error: errors.has('newPassword') }" v-validate="'required'" id= "newPassword" name="newPassword" type="password" class="form-control" placeholder="新しいパスワード" v-model="credentials.newPassword"/>
                        <i class="ace-icon fa fa-lock"></i>
                      </span>
                    </label>
                    <span class="newpassword-showhide">
                      <span class="show-password" @click="showhidePassword('newPassword' , 'show-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                      <span class="hide-password" @click="showhidePassword('newPassword' , 'hide-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                    </span>
                    <div class="note">
                      半角英大文字・半角英小文字・数字を組み合わせた8文字以上
                    </div>
                    </li>
                    <li>
                    <label class="clearfix">
                      <span class="label_title">新しいパスワード再入力</span>
                      <span class="input-icon input-icon-right">
                        <input :class="{ error: errors.has('newPassword') }" v-validate name="newPassword" id= "confirmnewPassword" data-vv-rules="required|confirmed:newPassword" type="password" class="block form-control" placeholder="新しいパスワード再入力" v-model="credentials.confirmnewPassword"/>
                        <i class="ace-icon fa fa-lock"></i>
                      </span>
                    </label>
                    <span class="confirm-password-showhide">
                      <span class="show-password" @click="showhidePassword('confirmnewPassword' , 'show-password' , 'confirm-password-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                      <span class="hide-password" @click="showhidePassword('confirmnewPassword' , 'hide-password' , 'confirm-password-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                    </span>
                    </li>
                    <div class="clearfix">
                      <button class="btn btn-info" type="submit">
                      パスワードを変更
                      </button>
                    </div>
                  </ul>
                </form>
                <!-- PAGE CONTENT ENDS -->
              </div><!-- /.col -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>
<script>
import * as Config from '../../config'
// import router from '../../router'

export default {
  data () {
    return {
      credentials: {
        oldPassword: '',
        newPassword: '',
        confirmnewPassword: ''
      },
      sucessStatus: false,
      error: '',
      message: ''
    }
  },
  created () {
  },
  methods: {
    showhidePassword (passwordId, classname, buttonname) {
      if (classname === 'show-password') {
        $('#' + passwordId).attr('type', 'text')
        $('.' + buttonname).find('.show-password').hide()
        $('.' + buttonname).find('.hide-password').show()
      } else {
        $('#' + passwordId).attr('type', 'password')
        $('.' + buttonname).find('.hide-password').hide()
        $('.' + buttonname).find('.show-password').show()
      }
    },
    validateBeforeSubmit () {
      this.sucessStatus = false
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.flagP = true
          if (!this.credentials.newPassword.match('^(?=.*[a-z])(?=.*[A-Z])(?=.*).{8,64}$')) {
            $('#passworderror').html('パスワードは英大文字、英小文字、数字を組み合わせた8文字以上に設定してください。')
            $('#newPassword').addClass('error')
            this.flagP = false
          } else {
            $('#passworderror').html('')
            $('#newPassword').removeClass('error')
            this.flagP = true
          }
          if (this.flagP) {
            const credentials = {
              oldPassword: this.credentials.oldPassword,
              newPassword: this.credentials.newPassword
            }
            this.$http.post(Config.CHANGE_PASSWORD_API, JSON.stringify(credentials))
              .then(response => {
                console.log(response)
                if (response.body.message === 'Success') {
                  // router.push({name: 'dashboard'})
                  this.sucessStatus = true
                  this.error = false
                  this.message = 'パスワードが変更されました。'
                  this.credentials.oldPassword = ''
                  this.credentials.newPassword = ''
                  this.credentials.confirmnewPassword = ''
                  this.$validator.reset()
                } else {
                  this.error = true
                  this.sucessStatus = false
                  this.message = Config.CHANGE_PASSWORD_API_ERROR
                }
              })
              .catch((error) => {
                if (error.body) {
                  this.sucessStatus = false
                  this.error = true
                  switch (error.status) {
                    case 400:
                      this.message = '現在のパスワードが間違っています。'
                      break
                    case 404:
                      this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                      break
                    case 500:
                      this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                      break
                    case 503:
                      this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                      break
                    default:
                      this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                      break
                  }
                } else {
                  this.error = true
                  this.message = Config.SERVER_CONNECT_ERROR
                }
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.UserChanegePassword .note{
  padding-left: 204px;
  padding-bottom: 15px;
  color: #808080;
}
.none-list {
  margin: 0px
}
.none-list li{
  list-style: none
}
.hide-password {
  display: none
}
.label_title{
  width: 200px;
  display: inline-block;
  text-align: left;
}
.tab-content .input-icon.input-icon-right>input{
  width: 350px
}
body{
  background: #394557
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
@media only screen and (max-width: 599px){
  .UserChanegePassword .note{
  padding-left: 0;
  }
}
@media only screen and (max-width: 375px){
  .tab-content .input-icon.input-icon-right>input{
  width: 270px
 }
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserChangePassword.vue